exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".notification {\n  position: fixed;\n  z-index: 102;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: #fff; }\n  .notification-wrapper {\n    text-align: center;\n    margin-top: 45px; }\n  .notification-title {\n    color: #379906;\n    font-size: 16px;\n    margin-bottom: 15px; }\n  .notification-back {\n    font-size: 17px;\n    padding: 0;\n    letter-spacing: -0.4px;\n    line-height: 1.2;\n    width: 48px;\n    height: 24px;\n    margin-top: 15px;\n    margin-left: 10px;\n    color: #004475; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/Notification/styles.scss
// module id = 1253
// module chunks = 0